@if ((command() || commands()) && commandType()) {
    <div class="st-production-command-dialog">
        <div class="st-production-command-dialog__header">
            <span>{{ title() }}</span>
        </div>
        <div class="st-production-command-dialog__body">
            @switch (commandType()) {
                @case (ProductionCommandType.INSERT) {
                    <st-insert-take-command-dialog
                        [command]="command()"
                        (enterEmitter)="editMode() ? updateCommand() : insertCommand()"
                        (commandChange)="commandChanged($event)" />
                }
                @case (ProductionCommandType.TAKE) {
                    <st-insert-take-command-dialog
                        [command]="command()"
                        (enterEmitter)="editMode() ? updateCommand() : insertCommand()"
                        (commandChange)="commandChanged($event)" />
                }
                @case (ProductionCommandType.ANCHOR) {
                    <st-anchor-command-dialog
                        [commands]="commands()"
                        (enterEmitter)="editMode() ? updateCommand() : insertCommand()"
                        (commandChange)="commandChanged($event)" />
                }
                @case (ProductionCommandType.DURATION) {
                    <st-duration-command-dialog
                        [command]="command()"
                        (enterEmitter)="editMode() ? updateCommand() : insertCommand()"
                        (commandChange)="commandChanged($event)" />
                }
                @case (ProductionCommandType.NOTES) {
                    <st-notes-command-dialog
                        [command]="command()"
                        (enterEmitter)="editMode() ? updateCommand() : insertCommand()"
                        (commandChange)="commandChanged($event)" />
                }
            }
        </div>
        <div
            *ngrxLet="languageSettings() as languageSettings"
            class="st-production-command-dialog__footer">
            <mat-button-toggle-group
                *ngrxLet="editMode() as isEditMode"
                class="st-production-command-dialog__footer-button-group">
                @if (isEditMode) {
                    <button
                        mat-button
                        class="st-production-command-dialog__footer-button-delete"
                        (click)="deleteCommand()">
                        {{ languageSettings.PSTWebTopicHoverDeleteText }}
                    </button>
                }
                <button
                    mat-button
                    class="st-production-command-dialog__footer-button-cancel"
                    (click)="cancel()">
                    {{ languageSettings.PSTWebCancelButtonLabel }}
                </button>
                @if (isEditMode) {
                    <button
                        mat-button
                        class="st-production-command-dialog__footer-button-confirm"
                        (click)="updateCommand()">
                        {{ languageSettings.PSTWebSaveButtonLabel }}
                    </button>
                } @else {
                    <button
                        mat-button
                        class="st-production-command-dialog__footer-button-confirm"
                        (click)="insertCommand()">
                        {{ languageSettings.PSTWebInsertButtonLabel }}
                    </button>
                }
            </mat-button-toggle-group>
        </div>
    </div>
}
